import { financesActionTypes } from 'src/store/actions';

import { FinanceDetailsState } from '../initial.state';

const FinanceReducer = (state = new FinanceDetailsState(), action) => {
  const { type, payload } = action || {};
  switch (type) {
    case financesActionTypes.GET_ALL_PAYMENTS:
      return {
        ...state,
        paymentsList: payload,
      };
    default:
      return state;
  }
};

export { FinanceReducer };
